module.exports = __webpack_public_path__ + "img/yiai-logo-light--h.be2962e2.png";